import InfoTags from './InfoTags';

export default InfoTags;
